export default "__VITE_ASSET__BgAq6q9t__"